import InboxSVG from './Inbox';
import UserMeditatesSVG from './UserMeditatesSVG';
import UserTouchesScreenSVG from './UserTouchesScreenSVG';
import UserFindsErrorSVG from './UserFindsErrorSVG';
import AlgoliaSVG from './AlgoliaSVG';

export { UserMeditatesSVG, InboxSVG, UserTouchesScreenSVG, UserFindsErrorSVG, AlgoliaSVG };
